import { Dropdown } from "react-bootstrap";
import React from "react";
import { useSettings } from "../../settings/SettingsProvider";

export const AccountSettingsItems: React.FC = () => {
    const { open: openSettings } = useSettings();

    return (
        <>
            <Dropdown.Header>My account</Dropdown.Header>
            <Dropdown.Item
                onClick={() => openSettings(["general"])}
                data-testid="settings-profile-button"
            >
                Profile
            </Dropdown.Item>
            <Dropdown.Item
                onClick={() => openSettings(["receipts"])}
                data-testid="settings-receipts-button"
            >
                Receipts
            </Dropdown.Item>
            <Dropdown.Item
                onClick={() => openSettings(["notifications"])}
                data-testid="settings-notifications-button"
            >
                Notifications
            </Dropdown.Item>
            <Dropdown.Item
                onClick={() => openSettings(["security"])}
                data-testid="settings-security-button"
            >
                Security
            </Dropdown.Item>
        </>
    );
};
